import { get, keys, includes, isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { getSearchLocationQuery, getLocale } from './index';

export const getDashboardData = state => get(state, 'dashboard.data', []);
export const getLoadedQuery = state => get(state, 'dashboard.loadedQuery');
export const getIsLoaing = state => get(state, 'dashboard.isLoading');

export const getSearchYearsRange = createSelector(
  getSearchLocationQuery,
  (query) => {
    let range = [2010, new Date().getFullYear()];
    const fromYear = get(query, 'fromYear');
    const toYear = get(query, 'toYear');
    if (!isEmpty(fromYear) && !isEmpty(toYear)) {
      range = [parseInt(fromYear), parseInt(toYear)];
    }
    return range;
  },
);

export const getSearchQuery = createSelector(
  getSearchYearsRange,
  getLocale,
  (yearsRange, locale) => {
    const [fromYear, toYear] = yearsRange;
    return {
      fromYear,
      toYear,
      locale,
    };
  },
);


// WEBPACK FOOTER //
// ./src/selectors/dashboard-selectors.js